<template>
  <q-dialog v-model="opened" no-backdrop-dismiss transition-show="none" transition-hide="none">
    <q-card style="max-width: 70vw;">
      <q-card-section class="q-pa-sm">
        <q-toolbar>
          <q-toolbar-title>
            Select Closures
          </q-toolbar-title>
        </q-toolbar>
      </q-card-section>

      <q-card-section class="q-pa-none">
        <q-toolbar class="bg-secondary text-white">
          <q-btn flat dense
                 icon="minimize"
                 @click="makeClosureForSelection">
            <q-tooltip :offset="[0, 10]">Create closure from selection.</q-tooltip>
          </q-btn>
          <q-btn flat dense
                 icon="undo"
                 @click="revertAllChanges">
            <q-tooltip :offset="[0, 10]">Revert all changes.</q-tooltip>
          </q-btn>

          <q-toolbar-title></q-toolbar-title>
        </q-toolbar>
        <ace-vue
          v-if="opened"
          :content="rememberText"
          :sync="true"
          ref="editor"
          :options="editorSettings"
          @change="codeChange(...arguments)"
          style="height: 300px; width: 40vw">
        </ace-vue>
      </q-card-section>
<!--      <ace-editor-->
<!--        v-if="opened"-->
<!--        :content="theirs"-->
<!--        :sync="true"-->
<!--        :options="aceOpts"-->
<!--        :readOnly="true"-->
<!--        @scrollV="scrollHandler(editor, ...arguments)">-->
<!--      </ace-editor>-->
      <q-btn @click="cancel" class="q-ma-sm" flat color="primary">Cancel</q-btn>
      <q-btn @click="save" class="float-right q-ma-sm" flat color="primary">Save</q-btn>
<!--      <q-btn @click="saveAndAdd" class="float-right q-ma-sm" flat color="primary">Save</q-btn>-->
    </q-card>
  </q-dialog>
</template>

<script>

import AceVue from './AceVue'
export default {
  name: 'RememberThisModal',
  components: { AceVue },
  data () {
    return {
      originalRememberText: '',
      rememberText: '',
      name: '',
      opened: false,
      responsePromise: null,
      resolvePromise: null,
      rejectPromise: null
    }
  },
  computed: {
    editorSettings () {
      // @see https://github.com/ajaxorg/ace/wiki/Configuring-Ace
      let editorSettings = this.$store.state.auth.currentUser.settings.editor
      let defaultOpts = {
        navigateWithinSoftTabs: true,
        animatedScroll: true,
        showInvisibles: false,
        printMargin: false,
        fontSize: '10px',
        // fontFamily: '',
        scrollPastEnd: 0.25,
        // theme: '',
        overwrite: false,
        newLineMode: 'auto', // "auto" | "unix" | "windows"
        useSoftTabs: true,
        useWorker: true,
        tabSize: 2,
        wrap: 'free',
        wrapBehavioursEnabled: true,
        foldStyle: 'markbegin', // "markbegin"|"markbeginend"|"manual"
        keyboardHandler: 'vim',
        mode: 'markdown'
      }
      if (this.$store.state.auth.currentUser == null) return defaultOpts
      if (this.$store.state.auth.currentUser.settings == null) return defaultOpts
      if (this.$store.state.auth.currentUser.settings.editor == null) return defaultOpts
      let opts = Object.assign(defaultOpts, editorSettings)
      delete opts['lineNumbers']
      return opts
    }
  },
  methods: {
    show (rememberText) {
      this.originalRememberText = rememberText
      this.rememberText = rememberText
      this.opened = true
      let t = this
      this.responsePromise = new Promise((resolve, reject) => {
        t.resolvePromise = resolve
        t.rejectPromise = reject
      })

      this.$nextTick(() => {
      })
      return this.responsePromise
    },
    scrollHandler (a, b) {
    },
    cancel () {
      this.rejectPromise()
      this.opened = false
    },
    save () {
      this.resolvePromise(this.rememberText)
      this.opened = false
    },
    codeChange (newValue) {
      this.rememberText = newValue
    },
    makeClosureForSelection () {
      let editor = this.$refs.editor.editor
      editor.session.replace(editor.selection.getRange(),
        `[_${editor.getSelectedText()}_]`)
    },
    revertAllChanges () {
      this.rememberText = this.originalRememberText
    }
  }
}
</script>

<style>
</style>
